// 不同国家对应的证件类型
export const identificationData = {
  Singapore: [
    {
      value: "NRIC (Citizen)",
      zh: "NRIC (Citizen) 新加坡公民身份证号",
      en: "NRIC (Citizen)",
    },
    {
      value: "NRIC (Permanent Resident)",
      zh: "NRIC (Permanent Resident) 新加坡永久居民身份证号",
      en: "NRIC (Permanent Resident)",
    },
    {
      value: "FIN",
      zh: "FIN 新加坡工作证准号",
      en: "FIN",
    },
    {
      value: "Passport/Others",
      zh: "Passport/Others 护照号/其他",
      en: "Passport/Others",
    },
  ],
  Malaysia: [
    {
      value: "Military ID number",
      zh: "Military ID number 军人身份证号",
      en: "Military ID number",
    },
    {
      value: "My Old IC number",
      zh: "My Old IC number 马来西亚旧身份证号",
      en: "My Old IC number",
    },
    {
      value: "MyKad",
      zh: "MyKad 马来西亚公民身份证",
      en: "MyKad",
    },
    {
      value: "MyKAS",
      zh: "MyKAS 马来西亚临时身份证",
      en: "MyKAS",
    },
    {
      value: "MyPR",
      zh: "MyPR 马来西亚永久居民身份证",
      en: "MyPR",
    },
    {
      value: "Non-citizen without passport number",
      zh: "Non-citizen without passport number 无护照非公民",
      en: "Non-citizen without passport number",
    },
    {
      value: "Official Receiver ID number",
      zh: "Official Receiver ID number 破产管理官身份证号",
      en: "Official Receiver ID number",
    },
    {
      value: "Passport number",
      zh: "Passport number 护照号",
      en: "Passport number",
    },
    {
      value: "Police ID number",
      zh: "Police ID number 警察身份证号",
      en: "Police ID number",
    },
  ],
};
